import * as React from "react";
import TabSet from "../../../hiberUiKit/src/molecules/TabSet/TabSet";
import Tab from "../../../hiberUiKit/src/atoms/Tab/Tab";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import TabSetContent from "../../../hiberUiKit/src/molecules/TabSet/TabSetContent";
import {Option} from "ts-option";
import AccountingNote from "../../../model/invoice/note/AccountingNote";
import {api} from "../../../api/api";
import AccountingNoteTab from "../common/AccountingNoteTab";
import Bill from "../../../model/bill/Bill";
import {OnFailure, OnSuccess} from "../../../store/action/actionHelpers";

interface IProps {
	/**
	 * Bill.
	 */
	bill: Option<Bill>;
	/**
	 * Note to edit.
	 */
	noteToEdit: Option<AccountingNote>
	/**
	 * On add note success callback.
	 */
	onAddNoteSuccess: (note: AccountingNote) => void;
	/**
	 * On edit note success callback.
	 */
	onUpdateNoteSuccess: (note: AccountingNote) => void;
}

export default class BillActivityTabs extends React.Component<IProps, {}> {
	render() {
		return (
			<React.Fragment>
				<TabSet>
					<Tab icon={Icon.Note} label={"Notes"} tabId={BillTab.Note} selectedTabId={BillTab.Note}/>
				</TabSet>
				<TabSetContent isWhite={true}>
					<AccountingNoteTab
						addNote={this.addNote}
						updateNote={this.updateNote}
						noteToEdit={this.props.noteToEdit}/>
				</TabSetContent>
			</React.Fragment>
		);
	}

	addNote = (noteContent: string, onSuccess: OnSuccess, onFailure: OnFailure) =>
		this.props.bill.map(b => {
			const successCallback = (note: AccountingNote) => {
				this.props.onAddNoteSuccess(note);
				onSuccess();
			};
			api.instance.noteApi.createBillNote(b.id, noteContent)
				.then(successCallback)
				.catch(onFailure)
		});

	updateNote = (noteId: string, noteContent: string, onSuccess: OnSuccess, onFailure: OnFailure) => {
		const successCallback = (note: AccountingNote) => {
			this.props.onUpdateNoteSuccess(note);
			onSuccess();
		};
		api.instance.noteApi.updateBillNote(noteId, noteContent)
			.then(successCallback)
			.catch(onFailure);
	}
}

export enum BillTab {
	Note = "note"
}
